import React from 'react'
import PropTypes from 'prop-types'
import styles from './Stack.scss'
import { classNames, variationName } from './../../utils/styles'
import { elementChildren, wrapWithComponent } from './../../utils/components'
import Item from './Item'

export default class List extends React.PureComponent {
  static Item = Item

  static propTypes = {
    vertical: PropTypes.bool,
    spacing: PropTypes.string,
    distribution: PropTypes.string,
    alignment: PropTypes.string,
    wrap: PropTypes.string,
    className: PropTypes.string,
    divider: PropTypes.string,
    children: PropTypes.any,
  }

  render() {
    const { className, vertical, spacing, distribution, alignment, wrap, children, divider } = this.props

    const classes = classNames(
      className && className,
      styles.Stack,
      vertical && styles.vertical,
      spacing && styles[variationName('spacing', spacing)],
      distribution && styles[variationName('distribution', distribution)],
      alignment && styles[variationName('alignment', alignment)],
      wrap === false && styles.noWrap,
    )

    const itemMarkup = elementChildren(children).map((child, index) => {
      return (
        <React.Fragment key={index}>
          {wrapWithComponent(child, Item, {})}
          {divider &&
            children.length - 1 > index && (
              <span className={styles.Item} key={`${index}Divider`}>
                {divider}
              </span>
            )}
        </React.Fragment>
      )
    })

    return <div className={classes}>{itemMarkup}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/Stack/Stack.js